<template>
  <billing-dialog class="zclips-plan-details" v-model="visible" show-close :dialog-name="title" :before-close="handleBeforeClose" @back-event="handleBeforeClose">
    <!--header-->
    <BasePlanDetails>
      <template #title>
      <span>{{ title }}</span>
      </template>
      <template #price>
        <price-list :plan-category="planCategory" :unit-type="planUnitMap.user"/>
      </template>
      <template #desc>
      <ul>
        <li v-for="item in descList" :key="item">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M11.3463 1.29932C7.60101 3.61712 5.1383 7.40082 5.1385 11.7005C5.1385 9.24482 3.5405 7.03792 1 5.51672"
              stroke="#0B5CFF" stroke-width="2.0157" stroke-linejoin="bevel" />
          </svg>
          <span>{{ item }}</span>
        </li>
      </ul>
      </template>
      <!-- <zm-button data-testid="checkout-button-125" slot="action" type="link" class="plan-details__confirm-btn text-capitalize" @click="handleSure">
        {{ $t('billing.pbx.plan_details.view_more') }}
      </zm-button> -->
    </BasePlanDetails>
  </billing-dialog>
</template>
<script type="text/jsx" lang="jsx">
import BasePlanDetails from '@/plans/EVENT_SAAS/component/dialog/plan-details/base.vue';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { planTypes } from '@/common/constants';
import { get } from 'lodash';
import { getTrackingProductNameByPlanType } from '@/aspects/trackings';
import PriceList from "@/components/price-list.vue";
import { planUnitMap } from '@/common/product-unit';
import BillingDialog from '@/components/billing-dialog.vue';

export default {
  name: 'PlanDetails',
  mixins: [ConfirmComponent],
  components: {
    PriceList,
    BasePlanDetails,
    BillingDialog,
  },
  props: {
    planList: Array,
    planType: String,
    title: String,
    planCategory: String,
  },
  data() {
    return {
      visible: false,
      planUnitMap,
    };
  },
  methods: {
    handleSure() {
      this.$tracking.buyInteraction('product details',
        `${this.trackingPlanKey} plan details -  view more`);
    },
    handleBeforeClose() {
      this.$tracking.buyInteraction('product details',
        `${this.trackingPlanKey} plan details - exit`);
      this.handleCancel();
    },
  },
  computed: {
    trackingPlanKey() {
      return getTrackingProductNameByPlanType(get(planTypes, this.planType));
    },
    descList() {
      return [
        this.$t('billing.zoom_clips_plus.easily_record_desc'), this.$t('billing.zoom_clips_plus.unlimited_videos_desc')
      ]
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(v) {
        v && this.$tracking.buyInteraction('product details', `${this.trackingPlanKey} plan details - impression`);
      }
    }
  },
}
</script>
<style lang="scss">
@import '@/styles/_variables.scss';

.zclips-plan-details {
  .zbo-dialog {
    padding: 72px 60px;
    min-width: 555px;
    width: fit-content;
  }

  .plan-details__price {
    display: flex;
  }

  .plan-details__desc {
    padding-left: 0;
    ul {
      li {
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
        list-style: none;
        margin-bottom: 12px;
        span {
          margin-left: 8px;
        }
      }
    }
  }
}
</style>
